<template lang="pug">
ValidationObserver(ref='form' v-slot='{ handleSubmit, invalid }')
  envelope-step-bar(:step='4')
  form(@submit.prevent='handleSubmit(submit)')
    .col-12.mt-4
      .card.card--rounded
        .card-body.p-4
          form.form
            .row
              .col-12.col-sm-6
                ValidationProvider(
                  name='nome do envelope'
                  rules='required'
                  v-slot='{ errors }'
                )
                  .form-group
                    label.review-label(for='subject') {{ $t('modal.envelope.review.title') }}
                    .form-control-icon
                      icon(name='file')
                      input#subject.form-control(
                        :class='{ "border-danger": remainingCaracters.title === 0 }'
                        :placeholder='$t("modal.envelope.review.titlePlaceholder")'
                        autocomplete='off'
                        maxlength='60'
                        type='text'
                        v-model='title'
                      )
                      max-text-counter(
                        :limit='60'
                        :value='title'
                        @remaining='remainingCaracters.title = $event'
                      )
                    small.text.text-danger {{ errors[0] }}
              .col-12.col-sm-6
                .form-group
                  .form-check(:class='{ disabled: !canAccessStorageMenu }')
                    input#saveToFolderCheckbox.form-check-input(
                      :disabled='!canAccessStorageMenu'
                      type='checkbox'
                      v-model='saveToFolderEnabled'
                    )
                    label.form-check-label.review-label(
                      for='saveToFolderCheckbox'
                    )
                      | {{ $t('modal.envelope.review.saveToFolder') }}
                      icon.fs-6.ms-1(
                        name='circle-question'
                        v-tooltip:top='$t("modal.envelope.review.saveToFolderHint")'
                      )
                  .form-control-icon.form-control-icon-select-folder(
                    :class='{ disabled: !canAccessStorageMenu || !saveToFolderEnabled }'
                    @click='saveToFolderEnabled && openModalSelectFolder()'
                  )
                    icon(name='folder')
                    .text.form-control(
                      :class='{ "text-muted": !saveToFolderEnabled }'
                    ) {{ textSelectedFolder }}
                      icon.text-end(name='chevron-right')
              .col-12.col-sm-6
                ValidationProvider(
                  name='envelope-limit-date'
                  rules='invalidDate'
                  v-slot='{ errors }'
                )
                  .form-group
                    label.review-label(for='signature-date-limit') {{ $t('modal.envelope.review.signatureDeadline') }}
                    .form-control-icon
                      icon(name='calendar')
                      date-picker-input#signature-date-limit.form-control(
                        :dateValue='expire_at'
                        :min-date='datePickMinDate'
                        :placeholder='$t("modal.envelope.review.signatureDeadlinePlaceholder")'
                        @change='validateDate($event, "signature-date-limit")'
                        type='text'
                        v-model='expire_at'
                      )
                    small.text.text-danger {{ errors[0] }}
              .col-12.col-sm-6(v-if='availableVisibilities.length')
                .form-group
                  label.review-label(for='visibility') {{ $t('modal.envelope.review.visibility') }}
                  select#visibility.form-control(v-model='visibilitySelected')
                    option(
                      :key='opt.value'
                      :value='opt.value'
                      v-for='opt in visibilityOptions'
                    ) {{ opt.label }}
              .col-12.col-sm-6(v-if='enableSignatureReminder')
                .form-group
                  label.review-label(for='signature-reminder')
                    | {{ $t('modal.envelope.review.signatureReminder') }}
                  select#signature-reminder.form-control(
                    v-model='action_reminder_frequency'
                  )
                    option(:value='null') {{ $t('modal.envelope.review.signatureReminderOptions.select') }}
                    option(value='24') {{ $t('modal.envelope.review.signatureReminderOptions.daily') }}
                    option(value='72') {{ $t('modal.envelope.review.signatureReminderOptions.every3Days') }}
                    option(value='120') {{ $t('modal.envelope.review.signatureReminderOptions.every5Days') }}
    .col-12.mt-4
      .card.card--rounded
        .card-body.p-4
          .row
            .col-12.col-sm-6
              ValidationProvider(
                name='signature-date-limit'
                rules='invalidDate'
                v-slot='{ errors }'
              )
                .form-group
                  label.review-label(for='subject') {{ $t('modal.envelope.review.subject') }}
                  .form-control-icon
                    icon(name='paper-plane')
                    input#subject.form-control(
                      :class='{ "border-danger": remainingCaracters.subject === 0 }'
                      :placeholder='$t("modal.envelope.review.subjectPlaceholder")'
                      autocomplete='off'
                      maxlength='60'
                      type='text'
                      v-model='subject'
                    )
                    max-text-counter(
                      :limit='60'
                      :value='subject'
                      @remaining='remainingCaracters.subject = $event'
                    )
            .col-12.mt-1
              .form-group
                label.review-label(for='message') {{ $t('modal.envelope.review.message') }}
                textarea#message.form-control(
                  :class='{ "border-danger": remainingCaracters.message === 0 }'
                  :placeholder='$t("modal.envelope.review.messagePlaceholder")'
                  maxlength='500'
                  style='min-height: 120px'
                  v-model='message'
                )
                max-text-counter(
                  :limit='500'
                  :value='message'
                  @remaining='remainingCaracters.message = $event'
                )
  envelope-bottom-bar(
    :disableButtonNextStep='invalid || isTemplate || showDropdown || (!teamsVisibilityConfig && isNextStepSubmitToReview) || (!canSend && !canSendToReview)'
    :disabledSend='!canSend'
    :disabledSubmitReview='isWaitingReview || isTemplate || !teamsVisibilityConfig'
    :enableSaveTemplate='processSaveTemplate'
    :hiddenButtonNextStep='showDropdown'
    :isSaveTemplatePage='isTemplate'
    :showDropdownButtonNextStep='showDropdown'
    :textButtonNextStep='labelNextStep'
    @nextStep='nextStep(defaultActionNextStep)'
    @save-template='checkSaveAsTemplate($event)'
    @saveAndClose='saveAndClose'
    @send='nextStep("send")'
    @submitToReview='nextStep("submitToReview")'
  )
  envelope-sent-modal(ref='envelopeSentModal')
  envelope-submitted-to-review-modal(ref='envelopeSubmittedToReviewModal')
  select-folder-modal(
    :enableRootDirectory='true'
    @selected-folder='selectedFolder'
    ref='selectFolderModal'
  )
  warning-save-and-close-envelope-modal(
    @discardChanges='discardChanges'
    @saveAndClose='saveAndClose'
    ref='warningSaveAndCloseEnvelopeModal'
  )
    p.mb-0 {{ $t('modal.envelope.review.warningSaveAndClose') }}
  no-credit-modal(@saveAndClose='saveAndClose' ref='noCreditModal')
  warning-change-envelope-reviewer-modal(
    @changeEnvelopeReviewer='changeEnvelopeReviewer'
    ref='changeEnvelopeReviewerModal'
  )
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import DatePickerInput from '@/ui/molecules/DatePickerInput.vue';
import EnvelopeState from '@/enums/EnvelopeState';
import EnvelopeSentModal from '@/modules/business/components/organisms/modals/EnvelopeSentModal.vue';
import NoCreditModal from '@/modules/business/components/organisms/modals/NoCreditModal.vue';
import EnvelopeStepBar from '@/ui/organisms/EnvelopeStepBar.vue';
import SelectFolderModal from '@/ui/organisms/modals/SelectFolderModal.vue';
import EnvelopeTriggerEvent from '@/enums/EnvelopeTriggerEvent';
import EnvelopeTrigger from '@/enums/EnvelopeTrigger';
// eslint-disable-next-line max-len
import WarningSaveAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseEnvelope.vue';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import StorageHttp from '@/services/StorageHttp';
import MaxTextCounter from '@/ui/atoms/MaxTextCounter.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';
import PermissionsService from '@/services/PermissionsService';
import ApiPermissions from '@/enums/ApiPermissions';
import alert from '@/modules/account/common/alert';
import {
  getAllowedVisibilities,
  getVisibilityOptions,
} from '@/modules/business/common/envelopeVisibility';
import EnvelopeSubmittedToReviewModal from '@/modules/business/components/organisms/modals/EnvelopeSubmittedToReviewModal.vue';
import Logger from '@/services/Logger';
import WarningChangeEnvelopeReviewerModal from '@/modules/business/components/organisms/modals/WarningChangeEnvelopeReviewerModal.vue';

export default {
  name: 'ReviewEnvelopePage',
  components: {
    WarningChangeEnvelopeReviewerModal,
    EnvelopeSubmittedToReviewModal,
    Icon,
    DatePickerInput,
    EnvelopeSentModal,
    EnvelopeStepBar,
    SelectFolderModal,
    WarningSaveAndCloseEnvelopeModal,
    EnvelopeBottomBar,
    NoCreditModal,
    MaxTextCounter,
  },
  data() {
    return {
      envelope: '',
      loading: false,
      subject: '',
      title: '',
      expire_at: '',
      action_reminder_frequency: '',
      message: '',
      selectFolder: null,
      saveToFolderEnabled: false,
      nextRoute: null,
      saveAsTemplate: false,
      remainingCaracters: {
        subject: 60,
        message: 60,
        title: 500,
      },
      visibilitySelected: null,
      teams: [],
      savedTemplate: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.savedTemplate ||
      to.name === 'business.envelope.fields' ||
      to.name === 'business.documents.sent' ||
      to.name === 'business.documents.waiting-review' ||
      to.name === 'business.documents.draft'
    ) {
      next();
      return;
    }
    this.$refs.warningSaveAndCloseEnvelopeModal.$refs.modal.open();
    this.nextRoute = next;
  },
  computed: {
    canUpdateInReview() {
      return (
        PermissionsService.can(
          this.$root.user,
          ApiPermissions.ENVELOPE_REVIEW_UPDATE
        ) &&
        PermissionsService.isSenderSameLoggedUserOrWithoutReviser(
          this.$root.user,
          this.envelope.sender
        )
      );
    },
    canAccessStorageMenu() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.STORAGE_VIEW
      );
    },
    isNextStepSubmitToReview() {
      return this.labelNextStep === this.$t('modal.envelope.submitToReview');
    },
    labelNextStep() {
      if (this.canSend || this.isWaitingReview) {
        return this.$t('button.send');
      }
      return this.$t('modal.envelope.submitToReview');
    },
    defaultActionNextStep() {
      if ((this.canSend && !this.canSendToReview) || this.isWaitingReview) {
        return 'send';
      }
      return 'submitToReview';
    },
    isWaitingReview() {
      return this.envelope.state === EnvelopeState.WAITING_REVIEW;
    },
    showDropdown() {
      return (
        !this.isTemplate &&
        !this.isWaitingReview &&
        this.canSendToReview &&
        this.canSend
      );
    },
    canSend() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.ENVELOPE_SEND
      );
    },
    canSendToReview() {
      return (
        PermissionsService.can(
          this.$root.user,
          ApiPermissions.ENVELOPE_UPDATE
        ) && this.teamsVisibilityConfig
      );
    },
    selectWhetherToSaveOrSend() {
      return (
        this.envelope.state !== EnvelopeState.IN_TRANSIT &&
        this.envelope.state !== EnvelopeState.EXPIRED
      );
    },
    enableSignatureReminder() {
      return this.expire_at && this.expire_at !== 'invalidDate';
    },
    textSelectedFolder() {
      return this.selectFolder
        ? this.selectFolder.name
        : this.$t('modal.envelope.review.storage');
    },
    datePickMinDate() {
      return new Date().fp_incr(1);
    },
    availableVisibilities() {
      return getAllowedVisibilities(this.$store.state.organizations.selected);
    },
    defaultVisibility() {
      const organizationSelected = this.$store.state.organizations.selected;
      return (
        organizationSelected?.metadata['envelope.default_visibility'] ?? null
      );
    },
    visibilityOptions() {
      return getVisibilityOptions({
        visibilities: this.availableVisibilities,
        teams: this.teams,
        translate: (key) => this.$t(key),
      });
    },

    isTemplate() {
      return (
        this.$route.params.isTemplate == true ||
        this.envelope.state === 'template'
      );
    },
    isNewTemplate() {
      return this.isTemplate && this.$route.params.isNewTemplate == true;
    },
    getPageTitle() {
      if (this.isNewTemplate) {
        return this.$t('newTemplate');
      } else if (this.isTemplate) {
        return this.$t('editTemplate');
      }
      return this.$t('editEnvelope');
    },
    processSaveTemplate() {
      return (
        this.$route.name === 'business.envelope.review' &&
        !this.isTemplate &&
        !this.isWaitingReview
      );
    },
    teamsVisibilityConfig() {
      return this.availableVisibilities.length > 0;
    },
  },
  watch: {
    visibilityOptions(opts) {
      if (this.visibilitySelected || !opts.length) {
        return;
      }
      this.applyPreferredVisibility();
    },
  },
  created() {
    let pageTitle = this.getPageTitle;
    this.$store.dispatch('page/setTitle', pageTitle);
    this.$store.dispatch('page/setHead', {
      title: pageTitle,
      action: () => {
        this.$router.replace({
          name: 'business.envelope.fields',
          params: {
            id: this.$route.params.id,
            isNew: this.$route.params.isNew,
            isTemplate: this.isTemplate,
            isNewTemplate: this.isNewTemplate,
          },
        });
      },
    });
  },
  async beforeMount() {
    const res = await EnvelopesService.getExtendedEnvelope(
      this.$route.params.id
    );
    const fileDirectory = res.data.triggers.find(
      (x) => x.trigger === EnvelopeTrigger.SAVE_FILES_ON_DIRECTORY
    );
    if (fileDirectory) {
      this.saveToFolderEnabled = true;
      StorageHttp.getItem(fileDirectory.value).then((result) => {
        this.selectedFolder(result.data);
      });
    }
    this.envelope = res.data;
    this.title = String(this.envelope.title.split('.', 1));
    this.subject = this.envelope.subject;
    this.expire_at = this.envelope.expire_at
      ? new Date(this.envelope.expire_at).fp_incr(1)
      : '';
    this.action_reminder_frequency = this.envelope.action_reminder_frequency;
    this.message = this.envelope.message;

    if (this.availableVisibilities.includes('team')) {
      try {
        const res = await TeamsService.list();
        this.teams = res.data.data;
      } catch (e) {
        this.teams = [];
      }
    }

    const visibilityOpts = this.visibilityOptions;
    const envelopeVisibility = this.envelope.visibility;
    let candidate = null;

    if (envelopeVisibility === 'team') {
      if (this.envelope.team) {
        candidate = `team:${this.envelope.team}`;
      }
    } else if (envelopeVisibility) {
      candidate = envelopeVisibility;
    }

    this.visibilitySelected =
      candidate && visibilityOpts.some((o) => o.value === candidate)
        ? candidate
        : null;

    if (!this.visibilitySelected) {
      await this.applyPreferredVisibility();
    }
  },
  methods: {
    async applyPreferredVisibility() {
      const opts = this.visibilityOptions;
      if (!opts.length || !this.defaultVisibility) {
        return;
      }

      if (this.defaultVisibility !== 'team') {
        if (opts.some((o) => o.value === this.defaultVisibility)) {
          this.visibilitySelected = this.defaultVisibility;
        }
        return;
      }

      const lastVisibility = await this.$store.dispatch(
        'envelopeSettings/getLastVisibility'
      );
      const lastTeam = lastVisibility ? `team:${lastVisibility}` : null;
      const lastTeamOption = lastTeam && opts.find((o) => o.value === lastTeam);
      const firstTeamOption = opts.find((o) => o.value.startsWith('team:'));

      this.visibilitySelected =
        (lastTeamOption && lastTeamOption.value) ||
        (firstTeamOption && firstTeamOption.value) ||
        null;
    },
    checkSaveAsTemplate(event) {
      this.saveAsTemplate = event;
    },
    async saveDetails() {
      if (this.isWaitingReview && !this.canUpdateInReview) {
        const revisorMessage = this.$t(
          'waitingReviewEnvelopesCardTable.insufficientPermission',
          { userRevisor: this.envelope.sender.email }
        );
        alert.fireAlert(this.$t(revisorMessage), {
          classes: 'alert-warning',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      this.$loading(true);
      const data = {};
      data.title = this.title;
      data.subject = this.subject;
      data.triggers = [];
      if (this.saveToFolderEnabled) {
        data.triggers.push({
          event: EnvelopeTriggerEvent.ENVELOPE_COMPLETED,
          trigger: EnvelopeTrigger.SAVE_FILES_ON_DIRECTORY,
          value: this.selectFolder ? this.selectFolder.id : null,
        });
      }
      data.action_reminder_frequency = this.action_reminder_frequency;
      if (this.expire_at) {
        data.expire_at = this.expire_at;
      }
      if (this.message) {
        data.message = this.message;
      }
      await EnvelopesService.update(this.$route.params.id, data);
      if (this.isTemplate) {
        this.savedTemplate = true;
      }

      if (this.availableVisibilities.length && this.visibilitySelected) {
        let visibility = this.visibilitySelected;
        let team = null;
        if (visibility.startsWith('team:')) {
          team = visibility.replace('team:', '');
          visibility = 'team';
        }
        const payload = { visibility };
        if (team) {
          payload.team = team;
        }
        await EnvelopesService.changeVisibility(this.$route.params.id, payload);
      }

      if (this.visibilitySelected?.startsWith('team:')) {
        await this.$store.dispatch(
          'envelopeSettings/saveLastVisibility',
          this.visibilitySelected.replace('team:', '')
        );
      }
      if (this.saveAsTemplate) {
        await EnvelopesService.copyTo('template', this.$route.params.id);
        this.savedTemplate = true;
      }
      this.$loading(false);
    },
    validateDate(event, inputId) {
      if (event === 'invalidDate') {
        document
          .querySelector(`#${inputId} + .date-input`)
          .classList.add('border-danger');
      } else {
        document
          .querySelector(`#${inputId} + .date-input`)
          .classList.remove('border-danger');
      }
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    async changeEnvelopeReviewer(event) {
      if (event === true) {
        try {
          this.$loading(true);
          await EnvelopesService.releaseEnvelopeReview(this.$route.params.id);
        } catch (error) {
          Logger.consoleError('Error to release envelope review', error);
        } finally {
          this.$loading(false);
        }
      }
      await this.$router.push({ name: 'business.documents.waiting-review' });
    },
    async saveAndClose() {
      await this.saveDetails();

      const destination = {
        name: this.savedTemplate
          ? 'business.documents.template'
          : 'business.documents.draft',
      };

      if (this.isWaitingReview) {
        this.$refs.changeEnvelopeReviewerModal.$refs.modal.open();
        return;
      }

      if (this.nextRoute) {
        this.nextRoute(this.savedTemplate ? destination : undefined);
        this.nextRoute = null;
        return;
      }
      this.$router.push(destination);
    },
    async nextStep(action = 'send') {
      const submittingToReview = action === 'submitToReview';

      const allowed = submittingToReview ? this.canSendToReview : this.canSend;

      if (!allowed) {
        const actionLabel = this.$t(`modal.envelope.${action}`);
        alert.fireAlert(
          this.$t('insufficientPermission', { action: actionLabel }),
          {
            classes: 'alert-warning',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          }
        );
        return;
      }

      const valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      await this.saveDetails();
      switch (action) {
        case 'send':
          await this.sendEnvelope();
          break;
        case 'submitToReview':
          if (!this.teamsVisibilityConfig) {
            const actionLabel = this.$t('noVisibilityOnOrganization');
            alert.fireAlert(
              this.$t('insufficientPermission', { action: actionLabel }),
              {
                classes: 'alert-warning',
                tag: 'httpAlert',
                icon: 'triangle-exclamation',
              }
            );
            return;
          }
          await this.submitEnvelopeToReview();
          break;
      }
    },
    async sendEnvelope() {
      if (this.isWaitingReview && !this.canUpdateInReview) {
        const revisorMessage = this.$t(
          'waitingReviewEnvelopesCardTable.insufficientPermission',
          { userRevisor: this.envelope.sender.email }
        );
        alert.fireAlert(this.$t(revisorMessage), {
          classes: 'alert-warning',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      if (!this.$store.getters['subscription/hasCredits']) {
        this.$refs.noCreditModal.$refs.modal.open();
        return;
      }
      this.$loading(true);
      try {
        if (this.selectWhetherToSaveOrSend) {
          await EnvelopesService.sendEnvelope(this.$route.params.id);
          this.$store.dispatch('subscription/getSubscription');
        }
        this.$refs.envelopeSentModal.$refs.modal.open();
      } catch (error) {
        if (error.response?.status === 402) {
          this.$refs.noCreditModal.$refs.modal.open();
        }
        Logger.consoleError('Failed to send envelope', error);
      } finally {
        this.$loading(false);
      }
    },
    async submitEnvelopeToReview() {
      this.$loading(true);
      try {
        if (this.isWaitingReview || !this.selectWhetherToSaveOrSend) {
          return;
        }
        await EnvelopesService.submitToReview(this.$route.params.id);
        this.$refs.envelopeSubmittedToReviewModal.$refs.modal.open();
      } catch (error) {
        Logger.consoleError('Failed to submit envelope to review', error);
      } finally {
        this.$loading(false);
      }
    },
    openModalSelectFolder() {
      if (!this.canAccessStorageMenu) {
        const action = this.$t('filesList.storage');
        alert.fireAlert(this.$t('insufficientPermission', { action }), {
          classes: 'alert-warning',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      this.$refs.selectFolderModal.$refs.modal.open();
    },
    selectedFolder(folder) {
      if (!folder) {
        this.selectFolder = null;
        return;
      }

      this.selectFolder = {
        name: folder.name,
        id: folder.id,
      };
    },
  },
};
</script>
<style lang="stylus">
.alert-warning
  margin: 1rem 0
  padding: 0.75rem 1rem
  background-color: #fff3cd
  border: 1px solid #ffeeba
  color: #856404
  border-radius: 4px
  text-align: center
.w-center
  margin: auto
  max-width: 960px
.form-control-icon-select-folder
  cursor: pointer;
  .icon
    color: #013d52
  .form-control
    padding-top: 0.7rem
    display: flex;
    justify-content: space-between;
  &.disabled
    opacity: 0.5
    pointer-events: none
    cursor: not-allowed
.review-label
  font-size: 1rem
.review-radius
  border-radius: .125rem
</style>
